<style lang="less">
@rem: 2rem;
#project-count {
	.project-pc {
		background-color: #f4f7fa;
		padding: 46px 0;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
	}
	.pcbox {
		border-radius: 12px;
		box-shadow: 0px 0px 10px 4px #edf1f4;
		max-width: 900px;
		padding: 30px 30px;
		margin: 0 auto;
		box-sizing: border-box;
		background-color: #fff;
		.logos {
			img {
				width: 156px;
				height: 45px;
			}
		}
		.titles {
			font-size: 24px;
			text-align: center;
			color: #333333;
			line-height: 44px;
			margin: 4px 0px 43px 0;
			box-sizing: border-box;
			width: 100%;
			.titleName {
				font-weight: 600;
				word-wrap: break-word;
				margin: 0 auto;
			}
			.text {
				font-size: 14px;
				color: #c1c5cc;
				line-height: 34px;
			}
		}
		.foot {
			text-align: center;
			color: #b8bcc4;
			margin: 39px 0;
		}
	}
	.webbox {
		display: none;
	}
	@media screen and (max-width: 768px) {
		.project-pc {
			display: none;
		}
		.webbox {
			width: 100vw;
			overflow: hidden;
			display: block;
			.noStatistics {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin: 200px auto 0;
				.pics {
					.icon {
						width: 287px / @rem;
						height: 312px / @rem;
					}
				}
				.text {
					padding-left: 30px;
					font-weight: 600;
					font-size: 14px;
				}
			}
			.topTitle {
				position: fixed;
				top: 0;
				left: 0;
				z-index: 11;
				width: 100%;
				height: 400px / @rem;
				background-color: #fff;
			}
			.title {
				word-wrap: break-word;
				text-align: center;
				padding: 0 10px;
				font-size: 48px / @rem;
				margin: 52px / @rem 0px 98px / @rem 0;
			}
			.content-box {
				width: 100%;
				background-color: #fff;
				margin-top: 400px / @rem;
			}
			.content {
				width: 100%;
				padding-bottom: 18px;
				.names {
					width: 100%;
					font-size: 14px;
					background-color: #f4f7fa;
					line-height: 62px / @rem;
					padding: 0 44px / @rem;
					box-sizing: border-box;
					font-weight: 600;
					word-wrap: break-word;
					white-space: normal;
				}
				.content-pic {
					width: 100%;
					font-size: 24px / @rem;
					color: #333;
					padding-left: 44px / @rem;
					box-sizing: border-box;

					.el-radio__label {
						color: #333 !important;
					}
					.el-radio__input.is-checked .el-radio__inner {
						border-color: #409eff;
						background: #409eff;
					}
					.el-radio__input.is-checked + .el-radio__label {
						color: #409eff !important;
					}
					.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
						background-color: #fff;
					}
					.el-checkbox-group {
						width: 100%;
					}
					.el-checkbox {
						width: 100%;
						word-break: break-all;
					}
					.el-checkbox__label {
						color: #333 !important;
						word-wrap: break-word;
						white-space: normal;
						margin-right: 22px;
					}
					.el-checkbox__input {
						position: absolute;
						top: 5px;
						left: -10px;
					}
					.el-checkbox__input.is-checked .el-checkbox__inner {
						border-color: #409eff;
						background: #409eff;
					}
					.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
						border-color: #fff !important;
					}
					.el-checkbox__input.is-checked + .el-checkbox__label {
						color: #409eff !important;
					}
					.radios_button {
						margin: 47px / @rem 0;
					}
					.picBoxs {
						position: relative;
						margin: 20px / @rem 0px 0px 40px / @rem;
						height: 24px / @rem;
						.graphical {
							display: inline-block;
						}
						.el-progress {
							width: 295px / @rem;
							.el-progress-bar {
								height: 24px / @rem;
							}
							.el-progress-bar__outer {
								background-color: #fff;
								height: 24px / @rem !important;
							}
							.el-progress-bar__inner {
								height: 24px / @rem;
							}
							.el-progress__text {
								display: none;
							}
						}
						.checkerColor {
							background-color: #2c7dfa;
						}
						.texts {
							position: absolute;
							right: 50px;
							display: inline-block;
							line-height: 24px / @rem;
						}
					}
				}
			}
		}
	}
}
</style>
<template>
	<div id="project-count">
		<div class="project-pc">
			<div class="pcbox">
				<header>
					<div class="logos">
						<img src="../../assets/img/ymhd_logo.png" alt="" />
					</div>
					<div class="titles">
						<div class="titleName">{{ title }}</div>
						<p class="text">
							您好,这次调查主要是为了了解当下人们举办会议的方式方法，非常感谢您对产品的支持与参与
						</p>
					</div>
				</header>
				<question-item v-for="(item, index) in projectList" :key="index" :item="item" />
				<div class="foot"><!-- 映目提供 --></div>
			</div>
		</div>
		<div class="webbox">
			<div class="topTitle">
				<div class="title">{{ title }}</div>
			</div>
			<div class="content-box" v-if="this.projectList.length > 0">
				<div v-for="(item, index) in projectList" :key="index" class="content">
					<div class="names">{{ item.title }}</div>
					<div v-for="(values, key, index) in item.data" :key="index" class="content-pic">
						<div class="radios_button">
							<el-radio-group v-if="item.type == '1'" v-model="item.answer">
								<el-radio :label="key" disabled>{{ key }} </el-radio>
							</el-radio-group>
							<div v-else class="allchecked">
								<el-checkbox-group v-model="item.answer">
									<el-checkbox :label="key" disabled>{{ key }}</el-checkbox>
								</el-checkbox-group>
							</div>
							<div class="picBoxs">
								<div class="graphical">
									<el-progress :percentage="values == 0 ? 2 : (values / item.total) * 100" />
								</div>
								<span class="texts">{{ values }}票</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else-if="isloading"></div>
			<div class="noStatistics" v-else>
				<div class="pics">
					<svg class="icon icon3" aria-hidden="true">
						<use xlink:href="#icon-xiangmukongzhuangtai" />
					</svg>
					<p class="text">暂无投票数据</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import questionItem from './questionItem.vue';
import { surveyAnswer, answerReport, survey } from '@/services/indexnew';

export default {
	components: {
		questionItem,
	},
	data() {
		return {
			isloading: true,
			projectList: [],
			itemId: '629',
			title: this.$route.query.title,
			oldMark: true,
		};
	},
	async mounted() {
		await this.getSurveyData();
		this.getData();
	},
	methods: {
		async getSurveyData() {
			const { data, ok } = await survey.getSingleInfo(this.$route.params.surveyId);
			if (!ok) return;
			this.oldMark = data.data.oldMark;
		},
		getData() {
			const surveyId = this.$route.params.surveyId;
			const source = this.$route.params.source;
			const apiObj = this.oldMark ? surveyAnswer : answerReport;
			var p1 = apiObj.getProjectStatistics(surveyId);
			//获取项幕数据回显
			var p2 = surveyAnswer.geteditorView(surveyId, source, (er) => {
				alert('res2 error');
				alert(er.toString());
			});
			Promise.all([p1, p2])
				.then((result) => {
					console.info(result);
					const [res1, res2] = result;
					this.isloading = false;
					// if(!res1){
					//   alert('no res1');
					// }
					// if(!res2){
					//   alert('no res2');
					// }
					// if(!(res1.code===0 && res2.code===0))
					// {
					//   throw new Error('res error');
					// }

					const projectList = res1.data.answerStatistics;
					const answerArr = res2.data;
					const ansMap = {};
					answerArr.forEach((item) => {
						ansMap[item.id] = item.answer.map((i) => {
							return i;
						});
					});
					const retData = [];
					projectList.forEach((item) => {
						const a = ansMap[item.id];
						if (item.type === 1) {
							const one = a ? a[0] : null;
							if (one) {
								if (one.type === 0) {
									item.answer = one.answer;
								} else {
									item.answer = '其他';
								}
							}
						} else if (item.type === 2) {
							const an = [];
							a.forEach((item) => {
								if (item.type === 0) {
									an.push(item.answer);
								} else {
									an.push('其他');
								}
							});
							item.answer = an;
						}
						retData.push(item);
					});
					this.projectList = retData;
				})
				.catch((error) => {
					alert(error.toString());
				});
		},
	},
};
</script>
